import { createSelector } from 'reselect';

const selectPopup = ({ popup }) => popup;

export const selectIsPopupActive = createSelector(selectPopup, ({ isActive }) => isActive);
